import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useSearchParams from '../hooks/useSearchParams'
import NavigationHeader from '../shared-navigation/navigation-header'
import NavigationSide from '../shared-navigation/navigation-side'
import NavigationWrapper from '../shared-navigation/navigation-wrapper'
import AsyncNavigationFooter from '../shared-navigation/navigation-footer'
import UseNotFoundProvider from '../../components/not-found/hooks/use-not-found-context'
import styles from './cancel-subscription.css'
import { PagedSearchResult } from '../../modules/search/components/paged-search-result/paged-search-result'
import { getConfigValue } from '../../utils/getConfigValue'
import { useConfig } from '../../hooks/use-config'
import { CANCEL_SUBSCRIPTION_SCREENS } from '../../constants'

const CancelSubscriptionLayout = ({ children }) => {
  const { hasSearchParams, location } = useSearchParams()

  // Apply background image only when GUEST_HOME_HOTSPOT_IMAGE is set in the config
  // and the current location is CANCEL_SUBSCRIPTION_OFFER
  const { appConfig } = useConfig()
  const guestHotspotImage = getConfigValue(appConfig?.values, 'GUEST_HOME_HOTSPOT_IMAGE')
  const gridImageBackgroundStyle = {}
  const isCancelOfferPage = location.pathname === CANCEL_SUBSCRIPTION_SCREENS.CANCEL_SUBSCRIPTION_OFFER.path
  if (isCancelOfferPage && guestHotspotImage) {
    gridImageBackgroundStyle.backgroundImage = `
      linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
      url(${guestHotspotImage})
    `
    gridImageBackgroundStyle.backgroundSize = 'cover'
    gridImageBackgroundStyle.backgroundPosition = 'center'
    gridImageBackgroundStyle.maxWidth = '100vw'
  }

  return (
    <UseNotFoundProvider>
      <div className={classnames(styles.layout, {
        [styles.whiteBackground]: !hasSearchParams
      })}
      >
        {!isCancelOfferPage && <NavigationHeader isMyAccountLayout />}
        {!isCancelOfferPage && <NavigationSide />}
        {hasSearchParams
          ? (
            <div className={styles.searchContent}>
              <NavigationWrapper>
                <PagedSearchResult />
                <AsyncNavigationFooter location={location} />
              </NavigationWrapper>
            </div>
          )
          : (
            <div
              className={styles.content}
              style={gridImageBackgroundStyle}
            >
              {children}
            </div>
          )}
      </div>
    </UseNotFoundProvider>
  )
}

CancelSubscriptionLayout.propTypes = {
  children: PropTypes.element
}

CancelSubscriptionLayout.defaultProps = {
  children: null
}

export default CancelSubscriptionLayout
